/* High Holler: vanilla JS. Age gate, header, marquee, reveal, dialogs, email check. */
(function () {
  'use strict';

  var COOKIE = 'hh_age_ok';
  var COOKIE_DAYS = 30;
  var MARQUEE_PX_PER_SEC = 40;

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function setCookie() {
    var secure = location.protocol === 'https:' ? '; Secure' : '';
    document.cookie = COOKIE + '=1; max-age=' + COOKIE_DAYS * 86400 + '; path=/; SameSite=Lax' + secure;
  }

  /* Age gate */
  function initAgeGate() {
    var gate = document.querySelector('[data-age-gate]');
    var page = document.getElementById('hh-page');
    if (!gate || document.documentElement.classList.contains('hh-age-ok')) return;

    var yes = gate.querySelector('[data-age-yes]');
    var no = gate.querySelector('[data-age-no]');
    var focusable = [yes, no].filter(Boolean);

    if (page) page.setAttribute('inert', '');
    document.documentElement.classList.add('hh-lock');
    if (yes) yes.focus();

    gate.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { e.preventDefault(); return; }
      if (e.key !== 'Tab' || focusable.length < 2) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });

    if (yes) {
      yes.addEventListener('click', function () {
        setCookie();
        document.documentElement.classList.add('hh-age-ok');
        document.documentElement.classList.remove('hh-lock');
        if (page) page.removeAttribute('inert');
        var main = document.getElementById('MainContent');
        if (main) main.focus({ preventScroll: true });
      });
    }
    /* "No" is a plain link to the URL set in the theme editor. */
  }

  /* Header turns solid after 80px */
  function initHeader() {
    var header = document.querySelector('[data-header]');
    if (!header) return;
    var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 80); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* Marquee speed: 40px per second */
  function initMarquee() {
    document.querySelectorAll('[data-marquee-track]').forEach(function (track) {
      var half = track.scrollWidth / 2;
      if (half > 0) track.style.setProperty('--marquee-duration', (half / MARQUEE_PX_PER_SEC) + 's');
    });
  }

  /* Fade up on first scroll into view */
  function initReveal() {
    var items = document.querySelectorAll('.hh-reveal:not(.is-in)');
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduced || !('IntersectionObserver' in window) || (window.Shopify && window.Shopify.designMode)) {
      items.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { entry.target.classList.add('is-in'); io.unobserve(entry.target); }
      });
    }, { threshold: 0.1 });
    items.forEach(function (el) { io.observe(el); });
  }

  /* Contact Sales dialog */
  function initDialogs() {
    document.querySelectorAll('[data-dialog-open]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var d = document.getElementById(btn.getAttribute('data-dialog-open'));
        if (d && d.showModal) d.showModal();
      });
    });
    document.querySelectorAll('[data-dialog-close]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var d = btn.closest('dialog');
        if (d) d.close();
      });
    });
    document.querySelectorAll('dialog[data-open-on-load]').forEach(function (d) {
      if (d.showModal && !d.open) d.showModal();
    });
  }

  /* Email check: show "Enter a valid email." instead of the browser bubble */
  function initEmailForms() {
    var pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    document.querySelectorAll('form.hh-form').forEach(function (form) {
      var input = form.querySelector('input[type="email"]');
      var error = form.querySelector('.hh-form__error');
      if (!input || !error) return;
      form.noValidate = true;
      form.addEventListener('submit', function (e) {
        var ok = pattern.test(input.value.trim());
        error.hidden = ok;
        input.setAttribute('aria-invalid', ok ? 'false' : 'true');
        if (!ok) { e.preventDefault(); input.focus(); }
      });
    });
  }

  function init() {
    initAgeGate();
    initHeader();
    initMarquee();
    initReveal();
    initDialogs();
    initEmailForms();
  }

  ready(init);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(initMarquee);
  document.addEventListener('shopify:section:load', function () { initMarquee(); initReveal(); });
})();
